import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import { useEffect, useState } from 'react';
import s from './styles.module.css';

// Фикс для отображения стандартных маркеров Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

const MapDetail = ({ latitude, longitude }) => {
    const position = {
        lat: latitude || 42.8746,
        lng: longitude || 74.6122,
    };

    return (
        <div className={s.mapComponents}>
            <MapContainer center={position} zoom={13} style={{ height: '420px', width: '100%' }}   zoomControl={false} doubleClickZoom={false}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <Marker position={position}>
                    <Popup>Местоположение объекта</Popup>
                </Marker>
            </MapContainer>
        </div>
    );
};

export default MapDetail;
